// extracted by mini-css-extract-plugin
module.exports = {"title":"create_prepublish__title___3edIb _type__vx_text-2___Qizsf","submit-button":"create_prepublish__submit-button___3vAq7"};